<template>
<v-content>
  <v-container fluid>
    <div id="content">
      <h2>{{ $route.name }}</h2>

      <section>
        <v-card flat>
          <v-card-title>
            <v-icon class="mr-2">fas fa-search</v-icon>
            <v-text-field v-model="listSearch" label="検索キーワード" single-line hide-details outlined dense></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="listColumns"
            :items="desserts"
            :search="listSearch"
            sort-by="id"
            :sort-desc="true"
            mobile-breakpoint="800"
            class="row-enabled"
            @click:row="onRowClick">
            <template v-slot:item.create_user="props">
              {{ getUser(props.item.create_user).company }}
            </template>
            <template v-slot:item.total="props">
              {{ calc(props.item.items) }} 円
            </template>
            <template v-slot:item.status="props">
              {{ status[props.item.status] }}
            </template>
          </v-data-table>
        </v-card>
      </section>

      <!-- 発注ダイアログ -->
      <v-dialog v-model="dialog" :scrollable="true" :persistent="true" fullscreen>
        <v-card>
          <v-card-title class="dialog-header">
            <span class="title font-weight-light">注文書</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-row no-gutters>
                <v-col cols="3" class="pa-2">
                  <v-text-field ref="id" label="発注No" v-model="editedItem.id" disabled></v-text-field>
                </v-col>
                <v-col cols="3" class="pa-2">
                  <v-text-field ref="id" label="発注日" v-model="editedItem.create_date" disabled></v-text-field>
                </v-col>
              </v-row>
              <!-- 発注商品のリスト -->
              <section class="pa-2">
                <v-data-table :headers="detailHeaders" :items="editedItem.items" hide-default-footer>
                  <template v-slot:item.price="props">
                    {{ separate(props.item.price) }} 円 / {{ props.item.unit }}
                  </template>
                  <template v-slot:item.quantity="props">
                    {{ separate(props.item.quantity) }} {{ props.item.unit }}
                  </template>
                  <template v-slot:item.subtotal="props">
                    {{ calcSubtotal(props.item) }} 円
                  </template>
                  <template v-slot:body.append>
                    <tr>
                      <td colspan="5"></td>
                      <td class="text-right">合計</td>
                      <td class="text-right">{{ calcTotal() }} 円</td>
                    </tr>
                  </template>
                </v-data-table>
              </section>
              <!-- その他の発注情報 -->
              <v-row no-gutters>
                <v-col cols="12" xs="12" class="pa-2">
                  <v-textarea ref="remarks" v-model="editedItem.remarks" rows="3" disabled>
                    <template v-slot:label>
                      <span>備考</span>
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="dialog-footer">
            <v-spacer></v-spacer>
            <v-btn color="error" @click="cancelItem" :loading="saving" v-if="editedItem.status == S_ORDER">
              <v-icon left>fas fa-times</v-icon>受注のキャンセル
            </v-btn>
            <v-btn @click="dialog = false">
              <v-icon left>fas fa-times</v-icon>閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </v-container>
</v-content>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
//import moment from 'moment'

export default {
  data() {
    return {
      prefix: 'DEMO', //発注書前置文字
      valid: false,
      detailValid: false,
      saving: false,
      dialog: false,
      itemsDialog: false,
      desserts: [],
      listSearch: null,
      listColumns: [
        { text: '注文No', value: 'id' },
        { text: '会社名', value: 'create_user' },
        { text: '合計金額', value: 'total', align: 'end' },
        { text: '取引ステータス', value: 'status' },
        { text: '希望納期', value: 'delivery_date' },
        { text: '注文日', value: 'create_date' },
      ],
      detailHeaders: [
        { text: 'メーカー', value: 'maker' },
        { text: '品名', value: 'name', sortable: false },
        { text: '型式・型番', value: 'model', sortable: false },
        { text: 'サイズ・寸法', value: 'size', sortable: false },
        { text: '仕切値', value: 'price', sortable: false, align: 'end' },
        { text: '数量', value: 'quantity', sortable: false, align: 'end', width: '120px' },
        { text: '小計', value: 'subtotal', sortable: false, align: 'end' },
      ],
      editedIndex: -1,
      editedItem: {
        items: [],
      },
      selectedItems: {},
      draft: false,
      status: {
        '00': '下書き',
        '10': '注文済',
        '11': '受注確定',
        '20': '納品済',
        '30': '検収済',
        '80': '注文のキャンセル',
        '90': '受注のキャンセル',
      },
      //S_DRAFT: '00',
      S_ORDER: '10',
      S_BUYER_CANCEL: '80',
      S_SUPPLIER_CANCEL: '90',
    }
  },
  prop: {},
  mounted() {},
  created() {
    this.setLoading(true)
    let timer = setInterval(() => {
      if (this.getMyself()) {
        clearInterval(timer)
        this.init();
      }
    }, 100)
  },
  computed: {

  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  methods: {
    init() {
      const path = this
      //発注書
      firebase.database().ref('orders').on('child_added', (data) => {
        path.updateItem(data.key, data.val())
      })
      firebase.database().ref('orders').on('child_changed', (data) => {
        path.updateItem(data.key, data.val())
      })
      firebase.database().ref('orders').on('child_removed', (data) => {
        path.desserts = path.desserts.filter(e => e.id !== data.key)
      })
      this.setLoading(false)
    },
    updateItem(key, item) {
      let data = Object.assign({
        id: key,
      }, item)
      let origin = this.desserts.find(e => e.id === key)
      if (origin) {
        origin = Object.assign(origin, data)
      } else {
        this.desserts.push(data)
      }
    },
    onRowClick(params) {
      this.editedIndex = this.desserts.findIndex(e => e.id === params.id)
      this.editedItem = Object.assign({}, params)
      this.dialog = true
    },
    //発注キャンセル
    cancelItem() {
      const path = this
      if (confirm('注文No「' + this.editedItem.id + '」 をキャンセルしますか？')) {
        //発注情報の保存
        let data = {
          status: this.S_SUPPLIER_CANCEL,
          update_date: this.getNowStr(),
          update_user: this.getMyself().id,
        }
        const id = this.editedItem.id
        //更新
        firebase.database().ref('orders/' + id).update(data, function(error) {
          if (error) {
            path.myAlert('受注のキャンセルに失敗しました')
          } else {
            path.log(path.getMyself().id, '受注のキャンセル = ' + id)
            path.dialog = false
          }
        })
      }
    },
    close() {
      this.saving = false
      this.dialog = false
      this.draft = false
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
      }, 300)
    },
    resetForm() {
      Object.keys(this.$refs).forEach(f => {
        this.$refs[f].reset()
      })
      Object.keys(this.editedItem).forEach(f => {
        this.editedItem[f] = Array.isArray(this.editedItem[f]) ? [] : null
      })
    },
    calcSubtotal(item) {
      let quantity = parseInt(item.quantity)
      let price = parseInt(item.price)

      if (!isNaN(quantity) && !isNaN(price)) {
        return this.separate(quantity * price)
      } else {
        return ''
      }
    },
    calcTotal() {
      return this.calc(this.editedItem.items)
    },
    calc(items) {
      let total = 0
      for (const item of items) {
        let quantity = parseInt(item.quantity)
        let price = parseInt(item.price)

        if (!isNaN(quantity) && !isNaN(price)) total += quantity * price
      }
      return this.separate(total)
    },
    statusFunc(row) {
      let color = 'white'
      switch(row.status) {
        case this.S_BUYER_CANCEL:
        case this.S_SUPPLIER_CANCEL:
          color = 'red lighten-4'
          break
        default:
          break
      }
      return color
    },
  }
}
</script>

<style scoped>

</style>
